var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMetamask = function SvgMetamask(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    width: "32px",
    color: "text",
    className: "sc-bdfBwQ hYmWca",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.7602 16.9155L51.9419 36.0497L56.7382 24.7733L77.7602 16.9155Z",
    fill: "#E17726"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2656 16.9155L43.8288 36.2283L39.2622 24.7733L18.2656 16.9155Z",
    fill: "#E27625"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4736 61.2808L61.6108 71.7918L76.3059 75.8482L80.4899 61.5104L68.4736 61.2808Z",
    fill: "#E27625"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5356 61.5104L19.6941 75.8482L34.3892 71.7918L27.5519 61.2808L15.5356 61.5104Z",
    fill: "#E27625"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5984 43.5251L29.491 49.699L44.0584 50.3624L43.5482 34.6724L33.5984 43.5251Z",
    fill: "#E27625"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4274 43.525L52.2991 34.4937L51.9419 50.3622L66.5094 49.6989L62.4274 43.525Z",
    fill: "#E27625"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3892 71.7922L43.1654 67.5316L35.6137 61.6128L34.3892 71.7922Z",
    fill: "#E27625"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8345 67.5316L61.6107 71.7922L60.3861 61.6128L52.8345 67.5316Z",
    fill: "#E27625"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6107 71.7923L52.8345 67.5317L53.5233 73.2465L53.4468 75.6446L61.6107 71.7923Z",
    fill: "#D5BFB2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3892 71.7923L42.5531 75.6446L42.502 73.2465L43.1654 67.5317L34.3892 71.7923Z",
    fill: "#D5BFB2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7062 57.8369L35.4097 55.6939L40.5631 53.3213L42.7062 57.8369Z",
    fill: "#233447"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2937 57.8369L55.4367 53.3213L60.6412 55.6939L53.2937 57.8369Z",
    fill: "#233447"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3893 71.7918L35.6649 61.2808L27.552 61.5104L34.3893 71.7918Z",
    fill: "#CC6228"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3352 61.2808L61.6108 71.7918L68.4736 61.5104L60.3352 61.2808Z",
    fill: "#CC6228"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5094 49.6987L51.9419 50.362L53.294 57.8371L55.4371 53.3215L60.6416 55.6941L66.5094 49.6987Z",
    fill: "#CC6228"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4098 55.6941L40.5633 53.3215L42.7063 57.8371L44.0584 50.362L29.491 49.6987L35.4098 55.6941Z",
    fill: "#CC6228"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M29.491 49.6987L35.6139 61.6129L35.4098 55.6941L29.491 49.6987Z",
    fill: "#E27525"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6414 55.6941L60.3862 61.6129L66.5092 49.6987L60.6414 55.6941Z",
    fill: "#E27525"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0584 50.3618L42.7063 57.8369L44.4156 66.6641L44.7728 55.0305L44.0584 50.3618Z",
    fill: "#E27525"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9415 50.3618L51.2527 55.005L51.5843 66.6641L53.2937 57.8369L51.9415 50.3618Z",
    fill: "#E27525"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2938 57.8374L51.5845 66.6646L52.8346 67.532L60.3862 61.6132L60.6413 55.6943L53.2938 57.8374Z",
    fill: "#F5841F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4097 55.6943L35.6138 61.6132L43.1654 67.532L44.4155 66.6646L42.7062 57.8374L35.4097 55.6943Z",
    fill: "#F5841F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4468 75.6443L53.5233 73.2462L52.8855 72.6849H43.1143L42.502 73.2462L42.5531 75.6443L34.3892 71.792L37.2465 74.1391L43.0378 78.1445H52.962L58.7533 74.1391L61.6107 71.792L53.4468 75.6443Z",
    fill: "#C0AC9D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8346 67.5315L51.5845 66.6641H44.4156L43.1655 67.5315L42.5022 73.2462L43.1145 72.6849H52.8857L53.5235 73.2462L52.8346 67.5315Z",
    fill: "#161616"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8314 37.2998L80.9999 26.7377L77.7599 16.9155L52.8345 35.4119L62.4271 43.5247L75.9485 47.4791L78.9335 43.984L77.6323 43.04L79.7243 41.1521L78.1426 39.902L80.2091 38.3458L78.8314 37.2998Z",
    fill: "#763E1A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M15 26.7377L17.194 37.2998L15.7909 38.3458L17.8574 39.902L16.2756 41.1521L18.3676 43.04L17.0665 43.984L20.0514 47.4791L33.5984 43.5247L43.1655 35.4119L18.2656 16.9155L15 26.7377Z",
    fill: "#763E1A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9487 47.4793L62.4272 43.5249L66.5092 49.6989L60.3862 61.613L68.4736 61.511H80.4898L75.9487 47.4793Z",
    fill: "#F5841F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5983 43.5249L20.0513 47.4793L15.5356 61.511H27.5519L35.6137 61.613L29.4908 49.6989L33.5983 43.5249Z",
    fill: "#F5841F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9415 50.3617L52.8344 35.4115L56.7378 24.7729H39.262L43.1653 35.4115L44.0583 50.3617L44.3899 55.0559L44.4154 66.664H51.5843L51.6099 55.0559L51.9415 50.3617Z",
    fill: "#F5841F"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMetamask, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/metamask.a65d9a9e.svg";
export { ForwardRef as ReactComponent };